import React from "react";
var functions = require("./functions.js");

// display the note
export function renderNoteSimple(cellData, rowData, rowIndex){
    let array=[];

    // create note
    let noteStr=cellData;
    if(!noteStr){
        noteStr="";
    }
    let note=React.createElement('pre',{ }, noteStr  ); 
    array.push(note);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}

export function renderErrorIfNotFacility(cellData, rowData, rowIndex){
    let array=[];

    // create note
    let cls="";
    if(cellData && cellData.includes("Association")){
        cls="error";
    }
    let note=React.createElement('span',{ class:cls}, cellData  ); 
    array.push(note);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}
// display a date
export function renderDateInTable(cellData, rowData, rowIndex){
    return functions.reactDate(cellData);
}
    // display the note
    export function renderNoteWithPossibleLink(cellData, rowData, rowIndex){
        let array=[];

        // create note
        let noteStr=cellData;
        if(!noteStr){
            noteStr="";
        }
        let title=React.createElement('h4',{}
            , "Date:"+ functions.formatDateTime(rowData.note_date)+"              Type:"+rowData.note_type);
        array.push(title);
        let note=React.createElement('pre',{ className:"render-note"}, noteStr  ); 
        array.push(note);

        if(noteStr.indexOf("http")===0){
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.preventDefault();
                        functions.openWindow(noteStr);
                    }
                    ,key:"buttonLink"+rowData.id
                }
                ,"Link");
            array.push(btnPlus);
        }
        // return div
        let div=React.createElement('div',{}, array );
        return div;    
    }
export function renderTextCopyToClipboard(cellData, rowData, rowIndex){
    let array=[];
    let txt=cellData;
    if(!txt){
        txt="";
    }
    if(txt==="null"){
        txt="";
    }   
    if(txt===null){
        txt="";
    }         
    //let img=React.createElement("img",{src:"icons8-clone-figure-32.png",height:"15px"},"")
    let btnPlus=React.createElement(
        'img'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                functions.copyToClipBoard(txt);
            }
            ,key:"buttonLink"+rowData.id
            ,src:"icons8-clone-figure-32.png"
            ,height:"15px"
        }

    );
    array.push(btnPlus);    
    array.push(React.createElement("span",{}," "+cellData));
    // return div
    let div=React.createElement('div',{}, array );
    return div;        
}
function addClipBoard(array,text){
    let btnClip=React.createElement(
        'img'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                functions.copyToClipBoard(text);
            }
            ,key:"buttonLink"+text
            ,src:"icons8-clone-figure-32.png"
            ,height:"15px"
        }

    );
    array.push(btnClip);      
}
export function renderHubspotContactLink(cellData, rowData, rowIndex){
    let array=[];
    let portalId=functions.getHubspotPortalId();  
    addClipBoard(array,cellData)
    let btnPlus=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation()
                functions.openWindow(`https://app.hubspot.com/contacts/${portalId}/record/0-1/${cellData}`);
            }
            ,key:"buttonLinkHubSpot"+rowData.id
        }
        ,`Contact ${cellData}`);
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}
export function renderHubspotDealLink(cellData, rowData, rowIndex){
    let array=[];
    let portalId=functions.getHubspotPortalId();
    let hubspotObjectId=rowData.hubspot_object_id;
    if(!hubspotObjectId){
        hubspotObjectId=rowData.hubspot_deal_id;
    }
    let btnPlus=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                functions.openWindow(`https://app.hubspot.com/contacts/${portalId}/record/0-3/${hubspotObjectId}`);
            }
            ,key:"buttonLinkHubSpot"+rowData.id
        }
        ,"HubSpot Deal");
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}
export function renderKatanaLink(cellData, rowData, rowIndex){
    let array=[];
    let portalId=functions.getHubspotPortalId();
    let hubspotObjectId=rowData.hubspot_object_id;
    if(!hubspotObjectId){
        hubspotObjectId=rowData.hubspot_deal_id;
    }
    let btnPlus=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                functions.openWindow(cellData);
            }
            ,key:"buttonLinkHubSpot"+rowData.id
        }
        ,"Katana");
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}
export function renderHubspotCompanyLink(cellData, rowData, rowIndex){
    let array=[];
    let portalId=functions.getHubspotPortalId();
    addClipBoard(array,cellData)
    let btnPlus=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                functions.openWindow(`https://app.hubspot.com/contacts/${portalId}/record/0-2/${cellData}`);
            }
            ,key:"buttonLinkHubSpot"+rowData.id
        }
        ,`Company ${cellData}`);
    array.push(btnPlus);
    
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}

export function renderShippoServiceLevel(cellData, rowData, rowIndex){
    /*let obj=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation()
                alert(
                    rowData.servicelevel.name+"\n"
                    +rowData.duration_terms+"\n"
                    +rowData.amount+" "+rowData.currency+"\n"
                )

            }
            ,style:{width:"130px"}
            ,key:"buttonLinkShippo"+rowData.id
        }
        ,rowData.servicelevel.name);
 */      
    //let obj=React.createElement('span', rowData.servicelevel.name );
    //array.push(obj);
    // return div
    //let div=React.createElement('div',{}, array );
    let div=React.createElement('div',{}, rowData.servicelevel.name );
    return div;    
}

export function renderProcessOrder(cellData, rowData, rowIndex){
    let array=[];
    let btnPlus=React.createElement(
        'button'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation()
                this.state.postObj.address_contact_id=rowData.hubspot_contact_object_id;                
                this.setState({
                    orderAddress:rowData
                    ,postObj:this.state.postObj
                    ,edited:true                    
                });
            }
            ,key:"buttonLinkOrder"+rowData.id
        }
        ,"Process Order using this Address ("+rowData.hubspot_contact_object_id+")");
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}
/*
this.state.postObj.address_contact_id=rowData.hubspot_contact_object_id;
this.setState({
    orderAddress:rowData
    ,postObj:this.state.postObj
    ,edited:true
*/    
export function renderMultiLineText(cellData, rowData, rowIndex){
    let array=[];
    let btnPlus=React.createElement(
        'pre'
        ,{ }
        ,cellData);
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
}

export function renderError(cellData, rowData, rowIndex){
    let array=[];
    let objType="span";
    let hover=cellData;
    if(rowData.error){
        objType="error";
        hover=rowData.error;
    }
    let btnPlus=React.createElement(
        objType
        ,{ title:hover}
        ,cellData);
    array.push(btnPlus);
    // return div
    let div=React.createElement('div',{}, array );
    return div;    
    
}
/*
    To run add this to the table columns:
    --------------------------------------
    { key: 'checked', title:"checked", width:10 , noquery:true, noedit:true,render:tableColumnRender.renderChecked.bind(this) }

    this will create an object
    ---------------------------
    this.state.checked

*/
export function renderChecked(cellData, rowData, rowIndex){
    let checked={}
    if(this.state.checked){
        checked=this.state.checked;
    } else {
        this.setState({
            checked:checked
        })
    }
    let checkedFile="icons8-checkbox-50-checked.png";
    let uncheckedFile="icons8-checkbox-50-unchecked.png";
    if(checked[rowData.id]){
        rowData.checkedIcon=checkedFile;
    } else {
        rowData.checkedIcon=uncheckedFile;
    }
    let array=[];
    let btnPlus=React.createElement(
        'img'
        ,{  onClick: (event) => 
            {   
                event.stopPropagation();
                if(this.state.checked[rowData.id]){
                    rowData.checkedIcon=uncheckedFile;
                    this.state.checked[rowData.id]=false;
                } else {
                    rowData.checkedIcon=checkedFile;
                    this.state.checked[rowData.id]=true;
                }                
                this.setState({
                    checked:this.state.checked
                })
            }
            ,key:"buttonChecked"+rowData.id
            ,src:rowData.checkedIcon
            ,height:"25px"
        }
    );
    array.push(btnPlus);    
    // return div
    let div=React.createElement('div',{style:{height:"40px",width:"40px","display": "flex","justify-content":"center","align-items": "center"},onClick:(event)=>{event.stopPropagation();}}, array );
    return div;   
}
/*
     getCheckedIdListString()

     requires this.state.checked object (not array eack elements key is the id record number)
     required being bound to component with check box
*/
export function getCheckedIdListString(obj){
    let result='(';
    let comma="";
    Object.keys(obj.state.checked).map((key) => { result+=comma+key;comma=",";});
    result+=')';
    return result;
}
